import { useMsal } from "@azure/msal-react";
import { useCallback } from "react";

/**
 * Header component with login/logout functionality
 */
const Header = () => {
  const { instance, accounts } = useMsal();
  const user = accounts[0];

  /**
   * Handle logout
   */
  const handleLogout = useCallback(() => {
    instance.logoutRedirect();
  }, [instance]);

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-title-section">
          <img 
            src="/Zentura bomærke - blå 2000px (Custom).png" 
            alt="Zentura Logo" 
            className="header-logo"
          />
          <h1 className="header-title">LMS Manager</h1>
        </div>
        
        <div className="header-actions">
          {user && (
            <>
              <div className="header-notifications">
                <button className="header-icon-button">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                    <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                  </svg>
                </button>
              </div>
              
              <div className="header-user">
                <span className="header-username">
                  {user.name || user.username}
                </span>
                <div className="header-avatar">
                  {(user.name || user.username || "U").charAt(0).toUpperCase()}
                </div>
                <div className="header-user-menu">
                  <button 
                    onClick={handleLogout}
                    className="btn btn-text"
                  >
                    Sign Out
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
